import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import SvgIcon from "@mui/material/SvgIcon";
const NotificationActiveIcon = forwardRef((props, ref) => {
  return /* @__PURE__ */ jsx(SvgIcon, { ...props, ref, children: /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "21.777", height: "26.075", viewBox: "0 0 21.777 26.075", children: /* @__PURE__ */ jsxs("g", { "data-name": "notification (1)", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        "data-name": "Path 21064",
        d: "M4.755 11.449a9.493 9.493 0 0 1 3.114-5.981.835.835 0 1 0-1.111-1.247A11.158 11.158 0 0 0 3.1 11.267a.854.854 0 0 0-.006.1v.009a.834.834 0 0 0 1.665.077z",
        transform: "translate(-2.99 -1.398)",
        fill: "currentColor",
        stroke: "currentColor",
        strokeWidth: ".2px"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        "data-name": "Path 21065",
        d: "M27.936 11.265a10.979 10.979 0 0 0-3.67-7.106.835.835 0 0 0-1.082 1.271 9.057 9.057 0 0 1 3.086 5.925.835.835 0 0 0 .835.835.86.86 0 0 0 .831-.925z",
        transform: "translate(-6.263 -1.389)",
        fill: "currentColor",
        stroke: "currentColor",
        strokeWidth: ".2px"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        "data-name": "Path 21066",
        d: "M23.145 19.332a11.7 11.7 0 0 1-1.54-5.8v-1.681A7.626 7.626 0 0 0 16.29 4.68a2.472 2.472 0 0 0 .31-1.18 2.5 2.5 0 1 0-5.008 0 2.472 2.472 0 0 0 .308 1.181 7.757 7.757 0 0 0-5.316 7.426v1.427a11.7 11.7 0 0 1-1.54 5.8 2.791 2.791 0 0 0-.253 2.957 2.478 2.478 0 0 0 2.166 1.248h3.8a3.339 3.339 0 1 0 6.677 0h3.8a2.478 2.478 0 0 0 2.166-1.25 2.855 2.855 0 0 0-.255-2.957zM14.093 2.669a.835.835 0 1 1-.835.835.836.836 0 0 1 .835-.835zm0 22.536a1.671 1.671 0 0 1-1.669-1.669h3.339a1.671 1.671 0 0 1-1.67 1.67zm7.862-3.754a.821.821 0 0 1-.722.416H6.953a.821.821 0 0 1-.722-.416c-.264-.454.034-.9.259-1.292a13.371 13.371 0 0 0 1.76-6.626v-1.426a6.092 6.092 0 0 1 5.833-6.1 5.96 5.96 0 0 1 5.852 5.842v1.683a13.372 13.372 0 0 0 1.759 6.625c.235.412.531.824.26 1.294z",
        transform: "translate(-3.217 -.9)",
        fill: "currentColor",
        stroke: "currentColor",
        strokeWidth: ".2px"
      }
    )
  ] }) }) });
});
export {
  NotificationActiveIcon
};
//# sourceMappingURL=NotificationActiveIcon.js.map
